import { Component, Input } from "@angular/core";

export interface ToastConfig {
  key: string;
  icon: string;
  iconWidth: string;
}

@Component({
  selector: "app-custom-toast-message",
  templateUrl: "./custom-toast-message.component.html",
  styleUrls: ["./custom-toast-message.component.scss"],
})
export class CustomToastMessageComponent {
  @Input() toastConfigs: ToastConfig[] = [
    {
      key: "sbc",
      icon: "/assets/images/icon-tick-moved.gif",
      iconWidth: "w-[25px]",
    },
    {
      key: "ibc",
      icon: "/assets/images/icon-move-inprogress.gif",
      iconWidth: "w-[25px]",
    },
    {
      key: "ebc",
      icon: "/assets/images/icon-warn-close.svg",
      iconWidth: "w-[16px]",
    },
    { key: "wbc", icon: "/assets/images/icon-info.svg", iconWidth: "w-[16px]" },
  ];

  @Input() position: any = "bottom-center";
  @Input() styleClass: string = "custom-toast-message";
}
